import React from 'react';
import { Nav, NavItem } from 'reactstrap';
import { footerMenu } from '../../../constants/menu';
import NavigationLink from '../../NavigationLink';
import './FooterNav.scss';

const FooterNav = () => (
  <Nav className="footer-nav">
    {footerMenu.map(({ label, url, external }) => (
      <NavItem key={label} className="footer-nav__item">
        <NavigationLink label={label} url={url} external={external} />
      </NavItem>
    ))}
  </Nav>
);

export default FooterNav;
